var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.82422C16 10.9459 15.1571 12.9808 13.6569 14.4811C12.1566 15.9813 10.1217 16.8242 8 16.8242C5.87827 16.8242 3.84344 15.9813 2.34315 14.4811C0.842855 12.9808 0 10.9459 0 8.82422C0 6.70249 0.842855 4.66766 2.34315 3.16737C3.84344 1.66707 5.87827 0.824219 8 0.824219C10.1217 0.824219 12.1566 1.66707 13.6569 3.16737C15.1571 4.66766 16 6.70249 16 8.82422Z",
    fill: "url(#paint0_linear_2_1666)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 13.5892C5.33301 13.7262 5.42701 13.8242 5.58301 13.8242C5.93401 13.8242 6.41901 13.1992 8.00001 13.1992C9.58101 13.1992 10.067 13.8242 10.417 13.8242C10.573 13.8242 10.667 13.7262 10.667 13.5892C10.667 13.1922 9.82801 11.8242 8.00001 11.8242C6.17201 11.8242 5.33301 13.1922 5.33301 13.5892Z",
    fill: "url(#paint1_linear_2_1666)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59872 9.6242C3.59872 8.8142 4.10772 8.1582 4.73272 8.1582C5.35972 8.1582 5.86672 8.8142 5.86672 9.6242C5.86672 9.9622 5.77772 10.2742 5.62872 10.5222C5.56211 10.6341 5.45387 10.715 5.32772 10.7472C5.18772 10.7842 4.97472 10.8242 4.73272 10.8242C4.48972 10.8242 4.27972 10.7842 4.13772 10.7472C4.01184 10.715 3.90393 10.634 3.83772 10.5222C3.67817 10.2501 3.59556 9.93966 3.59872 9.6242ZM10.1327 9.6242C10.1327 8.8142 10.6407 8.1582 11.2657 8.1582C11.8927 8.1582 12.3997 8.8142 12.3997 9.6242C12.3997 9.9622 12.3107 10.2742 12.1617 10.5222C12.1288 10.5777 12.0853 10.6261 12.0336 10.6647C11.982 10.7033 11.9232 10.7314 11.8607 10.7472C11.4708 10.8482 11.0616 10.8482 10.6717 10.7472C10.6092 10.7314 10.5504 10.7033 10.4988 10.6647C10.4471 10.6261 10.4036 10.5777 10.3707 10.5222C10.2115 10.25 10.1292 9.93958 10.1327 9.6242Z",
    fill: "url(#paint2_linear_2_1666)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2_1666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59872 9.6242C3.59872 8.8142 4.10772 8.1582 4.73272 8.1582C5.35972 8.1582 5.86672 8.8142 5.86672 9.6242C5.86672 9.9622 5.77772 10.2742 5.62872 10.5222C5.56211 10.6341 5.45387 10.715 5.32772 10.7472C5.18772 10.7842 4.97472 10.8242 4.73272 10.8242C4.48972 10.8242 4.27972 10.7842 4.13772 10.7472C4.01184 10.715 3.90393 10.634 3.83772 10.5222C3.67817 10.2501 3.59556 9.93966 3.59872 9.6242ZM10.1327 9.6242C10.1327 8.8142 10.6407 8.1582 11.2657 8.1582C11.8927 8.1582 12.3997 8.8142 12.3997 9.6242C12.3997 9.9622 12.3107 10.2742 12.1617 10.5222C12.1288 10.5777 12.0853 10.6261 12.0336 10.6647C11.982 10.7033 11.9232 10.7314 11.8607 10.7472C11.4708 10.8482 11.0616 10.8482 10.6717 10.7472C10.6092 10.7314 10.5504 10.7033 10.4988 10.6647C10.4471 10.6261 10.4036 10.5777 10.3707 10.5222C10.2115 10.25 10.1292 9.93958 10.1327 9.6242Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.61595 8.80978C4.74395 8.93478 4.75195 9.18178 4.63295 9.36078C4.51295 9.53878 4.31295 9.58278 4.18495 9.45678C4.05695 9.33178 4.04995 9.08478 4.16795 8.90678C4.28795 8.72778 4.48795 8.68478 4.61595 8.80978ZM11.105 8.80978C11.233 8.93478 11.241 9.18178 11.123 9.36078C11.003 9.53878 10.803 9.58278 10.673 9.45678C10.546 9.33178 10.539 9.08478 10.658 8.90678C10.777 8.72778 10.977 8.68478 11.105 8.80978Z",
    fill: "#4E506A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1572 5.97681C4.4892 5.82381 4.7532 5.75781 4.9582 5.75781C5.2352 5.75781 5.4092 5.87681 5.5082 6.06381C5.6832 6.39281 5.6042 6.46481 5.3102 6.52281C4.2042 6.74681 3.0932 7.46481 2.6112 7.91281C2.3102 8.19281 2.0222 7.88281 2.1752 7.63881C2.3292 7.39481 2.9492 6.53381 4.1572 5.97681ZM10.4922 6.06381C10.5912 5.87681 10.7652 5.75781 11.0422 5.75781C11.2482 5.75781 11.5112 5.82381 11.8432 5.97681C13.0512 6.53381 13.6712 7.39481 13.8242 7.63881C13.9772 7.88281 13.6902 8.19281 13.3892 7.91281C12.9062 7.46481 11.7962 6.74681 10.6892 6.52281C10.3952 6.46481 10.3182 6.39281 10.4922 6.06381Z",
    fill: "url(#paint3_linear_2_1666)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.8242C12.672 16.8242 12 16.0762 12 15.1532C12 14.2312 12.356 13.6082 12.643 13.0062C13.241 11.7482 13.359 11.5742 13.5 11.5742C13.641 11.5742 13.759 11.7482 14.357 13.0062C14.644 13.6082 15 14.2312 15 15.1532C15 16.0762 14.328 16.8242 13.5 16.8242Z",
    fill: "url(#paint4_linear_2_1666)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5002 14.4305C13.1722 14.4305 12.9062 14.1345 12.9062 13.7705C12.9062 13.4045 13.0473 13.1575 13.1613 12.9185C13.3973 12.4205 13.4442 12.3525 13.5002 12.3525C13.5562 12.3525 13.6032 12.4205 13.8392 12.9185C13.9532 13.1585 14.0942 13.4045 14.0942 13.7695C14.0942 14.1345 13.8282 14.4305 13.5002 14.4305Z",
    fill: "url(#paint5_linear_2_1666)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2_1666",
    x: 3.59863,
    y: 8.1582,
    width: 8.80106,
    height: 2.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0411227 0 0 0 0 0.0430885 0 0 0 0 0.0922353 0 0 0 0.819684 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_1666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_1666",
    x1: 8,
    y1: 2.46422,
    x2: 8,
    y2: 16.8242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69B30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_1666",
    x1: 8,
    y1: 11.8242,
    x2: 8,
    y2: 13.8242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#472315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B3A0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_1666",
    x1: 7.999,
    y1: 8.15822,
    x2: 7.999,
    y2: 10.8242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#3B426A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_1666",
    x1: 8,
    y1: 5.75822,
    x2: 8,
    y2: 8.02322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78E0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB6000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_1666",
    x1: 13.5,
    y1: 15.8742,
    x2: 13.5,
    y2: 12.5162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35CAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_1666",
    x1: 13.5,
    y1: 12.3522,
    x2: 13.5,
    y2: 14.4302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AE1FF",
    stopOpacity: 0.287
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8E3FF",
    stopOpacity: 0.799
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.824219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.0f90c1e5c9a4241533a86049f0ee0544.svg";
export { ForwardRef as ReactComponent };